<template>
    <div class="clearfix npagePage product">
        <div class="pde">
            <div class="carousel-inner">
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_01.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_02.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_03.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_04.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_05.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_06.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_07.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_08.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_09.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_10.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_11.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_12.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_13.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_14.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_15.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_16.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/V58W_17.jpg" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() { return {} }

}
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// ac2.vue?28294e3c